import { Card, IconCalendar } from "@dream/ui";
import { Link } from "@tanstack/react-router";
import { DreamLogo } from "../components/dream-logo.tsx";
import { calendarSearch } from "../router.tsx";

export function NotFoundPage() {
  return (
    <div className="flex h-full flex-col items-center justify-center gap-6 overflow-y-auto bg-[var(--color-surface-subtle)] px-4">
      <DreamLogo />
      <Card className="dream-enter w-full max-w-md p-6 text-center">
        <span className="mx-auto mb-4 flex size-12 items-center justify-center rounded-2xl bg-brand-50 text-brand-600">
          <IconCalendar className="size-5" />
        </span>
        <h1 className="text-base font-bold tracking-[0] text-[var(--color-ink)]">
          Página não encontrada
        </h1>
        <p className="mt-2 text-[0.8125rem] leading-5 text-[var(--color-ink-muted)]">
          O endereço não existe. O calendário do cliente fica em{" "}
          <code className="font-mono">/@cliente</code>. Links pontuais levam o código após{" "}
          <code className="font-mono">token=</code>.
        </p>
        <Link
          to="/calendario"
          search={calendarSearch()}
          className="mt-4 inline-block text-[0.875rem] font-medium text-brand-700 hover:underline"
        >
          Ir para o calendário
        </Link>
      </Card>
    </div>
  );
}
